import React from "react";

import parse, { HTMLReactParserOptions, domToReact } from "html-react-parser";
import { Element } from "domhandler/lib/node";

import Typography from "@mui/material/Typography";

export const stripHtml = (htmlToStrip: string): string => {
  return htmlToStrip.replace(/(<([^>]+)>)/gi, "").trim();
};

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.attribs && domNode.name === "p") {
      return (
        <>
          <Typography component="p">
            {
              domToReact(domNode.children, options)
            }
          </Typography>
        </>
      );
    }
  },
};

/**
 * @param html A string possibly containing HTML tags
 * @param preserveHTML Choose to parse or strip HTML tags
 */

const useHtml = (html: string | null, preserveHTML = true) => {
  if(!html) return ''
  return  preserveHTML ? parse(html, options) : stripHtml(html)
}

export default useHtml